export const MOBILE_DIALOG_DESKTOP_BREAKPOINT = 992;
export const MOBILE_DIALOG_OFFSET_HEIGHT = 80;
